import script from "./Bind.vue?vue&type=script&lang=ts&setup=true"
export * from "./Bind.vue?vue&type=script&lang=ts&setup=true"

import "./Bind.vue?vue&type=style&index=0&id=31638f32&lang=css"
import "./Bind.vue?vue&type=style&index=1&id=31638f32&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31638f32"]])

export default __exports__